<div class="dialog-container sai-dialog-shell" cdkScrollable [dir]="lang === 'en' ? 'ltr' : 'rtl'" *transloco="let t">
    <app-sai-dialog-header
        icon="heroicons_outline:paper-airplane"
        [title]="t('Send Message')"
        [subtitle]="t('Configure email and message for delivery')"
        [closeWithDialog]="true"
        [closeResult]="false"
    ></app-sai-dialog-header>

    <form [formGroup]="form" class="w-full">
        <div class="dialog-body flex flex-auto lg:gap-1 xl:gap-4 flex-wrap">
            <div class="w-full">
                <mat-form-field class="w-full relative fuse-mat-dense">
                    <mat-label>{{ t("Email") }}</mat-label>
                    <mat-icon
                        class="absolute top-[-1.6rem] p-2 text-2xl"
                        [ngClass]="lang === 'en' ? 'right-0' : 'left-0'"
                        [matTooltip]="t('Enter your email')"
                        >error_outline</mat-icon
                    >
                    <input matInput type="text" [formControlName]="'email'" />
                </mat-form-field>
                <small
                    *ngIf="
                        form.get('email').touched &&
                        form.get('email').hasError('required')
                    "
                    class="text-red-600"
                >
                    {{ t("Email is required") }}.
                </small>
                <small
                    *ngIf="
                        form.get('email').touched &&
                        form.get('email').hasError('email')
                    "
                    class="text-red-600"
                >
                    {{ t("Email is not valid") }}.
                </small>
            </div>

            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                <mat-label>{{ t("Message") }}</mat-label>
                <textarea
                    matInput
                    #descriptionField
                    [formControlName]="'message'"
                    maxlength="400"
                    [placeholder]="
                        t('Write a message to send within received email.')
                    "
                    [rows]="3"
                    [spellcheck]="true"
                    cdkTextareaAutosize
                ></textarea>
                <mat-hint align="end"
                    >{{ form.get("message").value?.length || 0 }}/400</mat-hint
                >
            </mat-form-field>
            <small
                *ngIf="
                    form.get('message').touched &&
                    form.get('message').hasError('required')
                "
                class="text-red-600"
            >
                {{ t("Message is required") }}.
            </small>
            <small
                *ngIf="
                    form.get('message').touched &&
                    form.get('message').hasError('maxlength')
                "
                class="text-red-600"
            >
                {{ t("Message must be less than 400 characters") }}.
            </small>
        </div>

        <div class="dialog-footer flex items-center justify-end w-full gap-4">
            <button
                type="button"
                class="px-6"
                mat-flat-button
                [mat-dialog-close]="false"
            >
                {{ t("Cancel") }}
            </button>

            <button
                type="button"
                class="px-8"
                mat-flat-button
                [disabled]="form.invalid"
                [class.bg-primary]="!form.invalid"
                [class.bg-invalid]="form.invalid"
                (click)="save()"
            >
                {{ t("Send") }}
            </button>
        </div>
    </form>
</div>
